import * as React from 'react';

import { Route, RouteProps } from 'react-router-dom';
import { PermissionEnum } from '../types';
import { withPermission, WithPermissionProps } from './withPermission';
import { RedirectToDashboard } from '../constants';

interface AuthorizedRouteProps extends RouteProps, WithPermissionProps {
  permission: PermissionEnum;
}

export const AuthorizedRoute: React.FunctionComponent<AuthorizedRouteProps> = ({
  permission,
  hasPerms,
  ...props
}) => {
  if (hasPerms) {
    return <Route {...props} />;
  } else {
    return RedirectToDashboard();
  }
};

export default withPermission()(AuthorizedRoute);
